module.exports = "/public/images/b8715d502af69378c2eba28141180d54.svg";